var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ bordered: _vm.bordered }},[(_vm.display)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }